import { Link } from 'react-router-dom';
import { MapPin, ArrowRight } from '@phosphor-icons/react';

export const NotFoundArea = () => (
  <main className="min-h-[60vh] flex items-center justify-center bg-[#FBF8F1] pt-32 pb-20">
    <div className="max-w-xl mx-auto text-center px-6">
      <MapPin weight="duotone" size={48} className="text-[#D4AF37] mx-auto mb-5" />
      <h1 className="font-serif-display text-3xl sm:text-4xl font-semibold text-[#800000] mb-4">
        That area page <span className="italic">isn't on the map yet.</span>
      </h1>
      <p className="text-[#5C5C5C] mb-8 leading-relaxed">
        India still serves your neighborhood — call (615) 347-3512 or browse all the areas she covers.
      </p>
      <Link
        to="/areas-we-serve"
        className="inline-flex items-center gap-2 bg-[#800000] text-white hover:bg-[#5C0000] transition-all px-7 py-3 rounded-sm font-semibold text-sm uppercase tracking-[0.15em]"
      >
        Browse All Service Areas <ArrowRight weight="bold" size={14} />
      </Link>
    </div>
  </main>
);
